import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=13bf9198&scoped=true&"
import script from "./Delivery.vue?vue&type=script&lang=ts&"
export * from "./Delivery.vue?vue&type=script&lang=ts&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=13bf9198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf9198",
  null
  
)

export default component.exports